// extracted by mini-css-extract-plugin
export default {"container":"RadioSwitch_container__RIA4B","switch":"RadioSwitch_switch__lPOGj","slider":"RadioSwitch_slider__KJQCL"};